import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { server } from "../server";

export const fetchMiscelleneousFeesDetails = createAsyncThunk(
  "miscelleneousFees/fetchMiscelleneousFeesDetails",
  async (_, thunkAPI) => {
    try {
      const response = await axios.post(
        `${server}/get_miscelleneous_feeHistory_mongodb`,
        {},
        {
          headers: { Authorization: `${localStorage.getItem("token")}` },
        }
      );

      const responseData = response.data?.["body-json"]?.body;

      if (Array.isArray(responseData)) {
        return responseData;
      } else {
        console.error("Invalid data format from API", response.data);
        return thunkAPI.rejectWithValue("Invalid data format");
      }
    } catch (error) {
      console.error("Error fetching fee details:", error);
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const miscelleneousFeesSlice = createSlice({
  name: "miscelleneousFees",
  initialState: {
    data: [],
    loading: false,
    error: "",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMiscelleneousFeesDetails.pending, (state) => {
        state.loading = true;
        state.error = "";
      })

      .addCase(fetchMiscelleneousFeesDetails.fulfilled, (state, action) => {
        state.data = action.payload
          .slice()
          .sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
        state.loading = false;
      })

      .addCase(fetchMiscelleneousFeesDetails.rejected, (state, action) => {
        state.error = action.payload;
        state.loading = false;
      });
  },
});

export default miscelleneousFeesSlice.reducer;
